export default __webpack_public_path__ + "static/media/helthcare-proider.ca38a28d.svg";